/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';
    
    export interface IProbe extends ITopologyElement, INetworkElement {
        name: string;
        serial: string;
        creationDate: Date;
        href: string;
        flexo: boolean;
        getDisplayLabel: () => string;
        canWrite?: boolean;
    }
    
    export class Probe implements IProbe {
        public name: string;
        public serial: string;
        public creationDate: Date;
        public networkInterfaces: INetworkInterface[];
        public x: number;
        public y: number;
        public href: string;
        public defaultGatewayId: number;
        public flexo: boolean;
        public canWrite: boolean;

        public static getDefaultOrderColumn(): string {
            return "creationDate";
        }

        public static Empty(): Probe {
            return new Probe();
        }

        public static Copy(probe: IProbe): Probe {
            let newProbe: Probe = new Probe();
            newProbe.name = probe.name;
            newProbe.serial = probe.serial;
            newProbe.creationDate = probe.creationDate;
            newProbe.networkInterfaces = probe.networkInterfaces;
            newProbe.x = probe.x;
            newProbe.y = probe.y;
            newProbe.href = probe.href;
            newProbe.defaultGatewayId = probe.defaultGatewayId;
            newProbe.flexo = probe.flexo;
            return newProbe;
        }

        constructor() {
            // empty constructor
            this.name = '';
            this.serial = '';
            this.creationDate = new Date();
            this.networkInterfaces = [];
            this.href = '';
            this.canWrite = false;
        }

        public getAvailableInterfaces(): INetworkInterface[] {
            return this.networkInterfaces.filter (
                (nic: INetworkInterface) => {
                    /* tslint:disable */
                    return nic.networkConnectedTo === null;
                    /* tslint:enable */
                }
            );
        }
        
        public getDefaultNetworkInterface(): INetworkInterface {
            return this.networkInterfaces ? this.networkInterfaces[0] : undefined;
        }

        public isConnectedToNetwork(): boolean {
            /* tslint:disable */
            return (this.networkInterfaces !== undefined && 
                    this.networkInterfaces[0] !== undefined &&
                    this.networkInterfaces[0].networkConnectedTo !== undefined &&
                    this.networkInterfaces[0].networkConnectedTo !== null);
            /* tslint:enable */ 
        }
        
        public class(): TopologyElementType {
            return TopologyElementType.Probe;
        }

        public getDisplayLabel(): string {
            return this.name;
        }
        
        public getDisplayImage(): string {
            return this.flexo ? 'images/iconmonstr-flexo-1-240.png' : 'images/iconmonstr-wireless-10-240.png';
        }
    }
}
